<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="xcm01" v-show="loading"></div>
    </transition>
    <transition name="el-fade-in-linear">
      <div class="xcm03" v-show="loading">
        <div class="xcm04">
          <div class="xcm05">
            <div class="xcm06">{{title}}</div>
            <div class="xcm07" @click="cancel">
              <img src="@/assets/images/guanb01.png" class="xcm12" alt="">
            </div>
          </div>
        </div>
        <div class="xcm08">
          <slot name="mbody"></slot>
        </div>
        <div class="xcm09" v-show="is_buttom">
          <div class="xcm10" @click="add">确定</div>
          <div class="xcm11" @click="cancel">取消</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "xc-model",
    data(){
      return{
      }
    },
    props:{
      loading:{
        type:Boolean,
        default() {
          return false;
        }
      },
      is_buttom:{
        type:Boolean,
        default() {
          return true;
        }
      },
      title:String,
      default() {
        return "捷米供应链";
      }
    },
    created() {
    },
    mounted() {
    },
    methods:{
      add(){
        this.$emit('evenModel');
      },
      cancel(){//点击取消
        this.$emit('cancel');
      }
    }
  }
</script>

<style scoped>
  .xcm01{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 999;
  }
  /*.xcm02{*/
  /*  width: 100%;*/
  /*  height: auto;*/
  /*  display: flex;*/
  /*  justify-content: center;*/
  /*  */
  /*}*/
  .xcm03{
    width: 640px;
    background-color: white;
    border-radius: 20px;

    position: absolute;
    z-index: 999;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
  }
  .xcm04{
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #EEEEEE;
  }
  .xcm05{
    width: 94%;
    margin-left: 3%;
    display: flex;
  }
  .xcm06{
    width: 80%;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    line-height: 56px;
  }
  .xcm07{
    width: 20%;
    font-size: 15px;
    color: #999999;
    line-height: 56px;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
  }
  .xcm08{
    width: 94%;
    margin-left: 3%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .xcm09{
    width: 94%;
    margin-left: 3%;
    display: flex;
    justify-content: flex-end;
    padding-top: 15px;
    padding-bottom: 15px;
    border-top: 1px solid #EEEEEE;
  }
  .xcm10{
    width: 64px;
    height: 41px;
    background-color: #0091FF;
    color: white;
    line-height: 41px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
  }
  .xcm11{
    width: 64px;
    height: 41px;
    line-height: 41px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    color: #666666;
    border: 1px solid #DDDDDD;
    margin-left: 10px;
  }
  .xcm12{
    width: 20px;
    height: 20px;
    margin-top: 18px;
  }
</style>